export const ASK_HELIX_ORG_COST_CONTRIBUTION_CAPABILITY_ID =
  'org_analysis_optimization' as const;

export const ASK_HELIX_ORG_COST_CONTRIBUTION_TOOL_NAME =
  ASK_HELIX_ORG_COST_CONTRIBUTION_CAPABILITY_ID;

export const ASK_HELIX_ORG_COST_CONTRIBUTION_INTENT_ID =
  'org_cost_ebitda_contribution' as const;

export const ASK_HELIX_ORG_COST_EVIDENCE_PACK_CONTEXT_KIND =
  `decision_agent:${ASK_HELIX_ORG_COST_CONTRIBUTION_CAPABILITY_ID}:evidence_pack` as const;
